import { useState } from "react";

interface DemoUser {
  tag: string;
  role: string;
  email: string;
  password: string;
  hue: number;
}

const DEMO_USERS: DemoUser[] = [
  {
    tag: "ENG",
    role: "Field Engineer",
    email: "eng.user@usg-demo.com",
    password: "Demo@1234",
    hue: 145,
  },
  {
    tag: "MGR",
    role: "Eng. Manager",
    email: "manager@usg-demo.com",
    password: "Demo@1234",
    hue: 200,
  },
  {
    tag: "OPS",
    role: "Operations Admin",
    email: "ops.admin@usg-demo.com",
    password: "Demo@1234",
    hue: 270,
  },
  { tag: "EXEC", role: "Executive", email: "exec@usg-demo.com", password: "Demo@1234", hue: 18 },
  {
    tag: "FIN",
    role: "Finance Lead",
    email: "finance@usg-demo.com",
    password: "Demo@1234",
    hue: 320,
  },
  {
    tag: "NEW",
    role: "New Engineer",
    email: "new.eng@usg-demo.com",
    password: "Demo@1234",
    hue: 165,
  },
];

const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";
const SANS = "'Inter Tight', 'Helvetica Neue', Helvetica, Arial, sans-serif";

interface DemoPanelProps {
  onFillCredentials: (email: string, password: string) => void;
}

export function DemoPanel({ onFillCredentials }: DemoPanelProps) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* Toggle row */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: "100%",
          background: "transparent",
          border: 0,
          padding: "12px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          borderTop: "1px solid rgba(11,23,20,0.12)",
        }}
      >
        <span
          style={{
            font: `500 10.5px/1 ${MONO}`,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "rgba(11,23,20,0.55)",
          }}
        >
          + Demo accounts <span style={{ opacity: 0.5 }}>{DEMO_USERS.length}</span>
        </span>
        <span
          style={{
            font: `500 11px/1 ${MONO}`,
            color: "rgba(11,23,20,0.55)",
            transition: "transform .2s ease",
            transform: open ? "rotate(45deg)" : "rotate(0deg)",
            display: "inline-block",
          }}
        >
          +
        </span>
      </button>

      {/* Expandable grid */}
      <div
        style={{
          maxHeight: open ? 600 : 0,
          overflow: "hidden",
          transition: "max-height .35s ease, padding .25s ease",
          paddingTop: open ? 8 : 0,
          paddingBottom: open ? 12 : 0,
        }}
      >
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {DEMO_USERS.map((user) => (
            <DemoCard key={user.email} user={user} onPick={onFillCredentials} />
          ))}
        </div>
      </div>
    </div>
  );
}

function DemoCard({
  user,
  onPick,
}: {
  user: DemoUser;
  onPick: (email: string, password: string) => void;
}) {
  return (
    <button
      type="button"
      onClick={() => onPick(user.email, user.password)}
      style={{
        textAlign: "left",
        background: "rgba(11,23,20,0.04)",
        border: "1px solid rgba(11,23,20,0.10)",
        borderLeft: `2px solid oklch(0.72 0.16 ${user.hue})`,
        padding: "10px 12px",
        cursor: "pointer",
        color: "#0B1714",
        transition: "background .15s ease",
        borderRadius: 2,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.background = "rgba(11,23,20,0.07)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.background = "rgba(11,23,20,0.04)";
      }}
    >
      <div
        style={{
          font: `500 9.5px/1 ${MONO}`,
          letterSpacing: "0.16em",
          color: `oklch(0.60 0.16 ${user.hue})`,
          marginBottom: 6,
        }}
      >
        {user.tag}
      </div>
      <div style={{ font: `600 13px/1.2 ${SANS}`, letterSpacing: "-0.01em", marginBottom: 4 }}>
        {user.role}
      </div>
      <div
        style={{
          font: `400 10.5px/1.2 ${MONO}`,
          color: "rgba(11,23,20,0.55)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {user.email}
      </div>
    </button>
  );
}
